import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { LearningDesignResource } from '../../../../../../Types';
import CompetencyFilterStore from '../CompetencyFilter/Store';
import ProductTypeFilterStore from '../ProductTypeFilter/Store';
import FilteredLearningDesign from './FilteredLearningDesign';
import { showFilteredLearningDesigns } from './Filtering';

interface Props {
  learningDesignResource: LearningDesignResource;
  competencyFilterStore: CompetencyFilterStore;
  productTypeFilterStore: ProductTypeFilterStore;
  learningDesignId: Maybe<number>;
  setLearningDesignId: (id: Maybe<number>) => void;
}

const LearningDesign: React.FC<Props> = ({
  learningDesignResource,
  productTypeFilterStore,
  competencyFilterStore,
  learningDesignId,
  setLearningDesignId,
}) =>
  showFilteredLearningDesigns(
    competencyFilterStore.state.filter,
    productTypeFilterStore.state.filter,
    learningDesignResource,
  )
    .map((resource) => (
      <FilteredLearningDesign
        learningDesignResource={resource}
        key={learningDesignResource.payload.id}
        learningDesignId={learningDesignId}
        setLearningDesignId={setLearningDesignId}
        dataIntercomTarget="learning-design-option"
      />
    ))
    .getOrElse(() => <></>);

export default observer(LearningDesign);
